module.exports = __webpack_public_path__ + "img/freepass_use01.68b5038c.png";